export enum ScoreDisplay {
  ProgressPercent = 'progressPercent',
  ScorePercent = 'scorePercent',
  ScoreNumber = 'scoreNumber',
}
